import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { TestCreditCardsPage } from 'src/app/model/page/group/api-docs/test-credit-cards-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-test-credit-cards-page',
  templateUrl: './test-credit-cards-page.component.html',
  styleUrls: ['./test-credit-cards-page.component.scss']
})
export class TestCreditCardsPageComponent implements OnInit {
  testCreditCardsPage: TestCreditCardsPage = {} as TestCreditCardsPage;

  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'test-credit-card') {
        this.testCreditCardsPage.htmlTitle = title.htmlTitle;
      }
    });
    this.testCreditCardsPage.sections = [];
    this.testCreditCardsPage.tableSections = [];
    this.testCreditCardsPage.noteSections = [];

    const query = { 'fields.title': 'Test Credit Cards' };
    this.contentfulService.getPageContentResponse(query).then((testCreditCardsPageEntries) => {
      this.mapBanner(testCreditCardsPageEntries.includes.Entry);
      this.sharedDataService.addSharedData(this.testCreditCardsPage.banner);
      this.mapNoteSections(testCreditCardsPageEntries.includes.Entry);
      this.mapSections(testCreditCardsPageEntries.includes.Entry);
      this.mapTableSection(testCreditCardsPageEntries.includes.Entry);
      this.mapPageInfo(testCreditCardsPageEntries.items);
    });
  }

  private mapBanner(testCreditCardsPageEntries: Entry<any>[]) {
    testCreditCardsPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let image: any = entry.fields['image'] as string;
    let video: any = entry.fields['video'] as string;
    this.testCreditCardsPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: image.fields.file.url,
      video: video?.fields?.file?.url
    };
  }

  private mapSections(testCreditCardsPageEntries: Entry<any>[]) {
    testCreditCardsPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
      });

    this.testCreditCardsPage.sections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToSection(entry: Entry<any>) {
    let givenTitle: any = entry.fields['title'] as string;
    let pageTitle = givenTitle.split('#')[1];
    this.testCreditCardsPage.sections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number
    });
  }

  private mapNoteSections(ndcRegistrationPageEntries: Entry<any>[]) {
    ndcRegistrationPageEntries
      .filter((entry) => ModelValidator.isNote(entry))
      .forEach((entry) => {
        this.mapEntryToNoteSection(entry);
      });

    this.testCreditCardsPage.noteSections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToNoteSection(entry: Entry<any>) {
    let title: any = entry.fields['title'] as string;
    this.testCreditCardsPage.noteSections.push({
      fullTitle: entry.fields['title'] as string,
      title: title.split('#').pop(),
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      noteClass: entry.fields['noteClass'] as string,
      iconClass: entry.fields['iconClass'] as string
    });
  }

  private mapTableSection(testCreditCardsPageEntries: Entry<any>[]) {
    testCreditCardsPageEntries
      .filter((entry) => ModelValidator.isTableSection(entry))
      .forEach((entry) => {
        this.mapEntryToTableSection(entry);
      });
    this.testCreditCardsPage.tableSections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToTableSection(entry: Entry<any>) {

    let givenTitle:any=entry.fields['title'] as string;
    let pageTitle=givenTitle.split('#')[2];

    this.testCreditCardsPage.tableSections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      table: entry.fields['table'] as string,
      heading: entry.fields['heading'] as string
    });
    this.testCreditCardsPage.tableSections.sort((a, b) => a.order - b.order);
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      let editorDetails = entry.fields?.editorDetails?.split('#');
      this.testCreditCardsPage.banner.lastUpdated = entry.fields?.lastUpdated;
      this.testCreditCardsPage.banner.url = entry.fields?.url;
      this.testCreditCardsPage.banner.editorEmail = editorDetails?.pop();
      this.testCreditCardsPage.banner.editorShortName = editorDetails?.pop();
      this.testCreditCardsPage.banner.editorFullName = editorDetails?.pop();
      this.testCreditCardsPage.htmlTitle = entry.fields.htmlTitle;
    });
  }
}
